'use client';

/* eslint-disable react-hooks/exhaustive-deps */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { replaceUrls } from 'utils/urls';

export default function PreviewBanner({ previewBannerText, environment }) {
  const [bannerText, setBannerText] = useState('');

  useEffect(() => {
    const url = replaceUrls(
      previewBannerText?.html || 'https://shop.hellolingo.com/en-GB/products',
      environment,
    );
    setBannerText(url);
  }, [environment]); // TODO: Fix exhaustive dependencies

  if (previewBannerText?.html) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        data-testid='topPreviewBannerBox'
        sx={{
          backgroundColor: 'rgba(10, 137, 255, 1)',
          height: {
            xs: '46px',
            md: '74px',
          },
        }}
      >
        <Typography
          color='rgba(255, 255, 255, 1)'
          data-testid='topPreviewBanner'
          variant='bodyMSemibold'
          fontSize={{ xs: '14px', md: '16px', lg: '16px' }}
          sx={{
            fontWeight: '600',
            fontStyle: 'normal',
            letterSpacing: '-0.32px',
            lineHeight: '26px',
            '& a': {
              color: 'rgba(255, 255, 255, 1)',
              textDecoration: 'underline',
              fontWeight: '300',
              cursor: 'pointer',
            },
          }}
          dangerouslySetInnerHTML={{ __html: bannerText }}
        />
      </Box>
    );
  }
}
